import { object } from 'prop-types';
import React from 'react';
import { BQLink } from '../bqlink';
import SvgIcon from '../svg-icon';
import './breadcrumb-basic.m.css';

const BreadcrumbBasic = (props) => {
  let sectionName = !props?.podcastPage ? 'Exclusives' : 'Podcasts';
  let sectionSlug = !props?.podcastPage ? 'exclusive' : '';

  if (Array.isArray(props?.story?.sections)) {
    for (let i = 0; i < props?.story?.sections?.length; i++) {
      const section = props?.story?.sections[i];
      if ('display-name' in section) {
        sectionName = section['display-name'];
        sectionSlug = section.slug;
        break;
      }
    }
  }

  return (
    <div styleName="floating-breadcrumb" className="desktop-only">
      <div styleName="breadcrumb" className="container">
        <BQLink story={props?.story} href={'/?src=story-page'}>
          <SvgIcon type="home-icon-dark" source="image" height="40" />
        </BQLink>
        <span styleName="dot"></span>
        <span>
          {props?.podcastPage ? (
            <div>{sectionName}</div>
          ) : (
            <BQLink href={`/${sectionSlug}?src=story-page`}>{sectionName}</BQLink>
          )}
        </span>
        <span styleName="dot"></span>
        <span styleName="breadcrumb-headline">
          {!props?.podcastPage ? props.story?.headline : props?.podcastName}
        </span>
      </div>
    </div>
  );
};

BreadcrumbBasic.propTypes = {
  story: object,
};

export default BreadcrumbBasic;
